import React, { useState , useEffect } from 'react';
import { MdOutlineCancel } from 'react-icons/md';
import { useStateContext } from '../../contexts/ContextProvider';
import { usePersonasMutations } from '../../hooks/personas/usePersonasMutations.jsx';
import { ButtonSubmit, FooterPages } from '..';
import { fetchUser } from '../../utils/fetchUser';

const initialState = {
  rut: '',
  nombres: '',
  apellidoPaterno: '',
  apellidoMaterno: '',
  paisNacimiento: '',
  fechaNacimiento: '',
  genero: '',
  estadoCivil: '',
  region: '',
  ciudad: '',
  direccion: '',
  telefonoFijo: '',
  telefonoMovil: '',
  email: '',
  especialidad: '',
  cargoMuestraInteres: '',
  observaciones: '',
  fechaCreacion: '',
};

const NuevaPersona = ({vecinoData, onChangeVecino}) => {
  const { currentColor, isClicked, setIsClicked } = useStateContext();
  const [formData, setFormData] = useState(initialState);
  const { addPersona, updatePersonaC } = usePersonasMutations();
  const inputClass = "text-[11px] border border-gray-300 p-1.5 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-400";

  useEffect(() => {
    if (vecinoData) {
      setFormData({
        ...initialState,
        ...vecinoData,
        fechaNacimiento: vecinoData.fechaNacimiento ? new Date(vecinoData.fechaNacimiento).toISOString().split('T')[0] : ''
      });
    } else {
      setFormData(initialState);
    }
  }, [vecinoData]);

  const handleChange = (e) =>{
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Validaciones mínimas
    if (!formData.rut || !formData.nombres) return;
    const userInfo = fetchUser();

    const dataToSend = {
      ...formData,
      empresa: userInfo.empresa,
      fechaCreacion: formData.fechaCreacion || new Date(),
    };

    // Normalize fechaNacimiento to midday UTC to avoid timezone shifts when converting to Date
    if (formData.fechaNacimiento) {
      // Ensure we have a YYYY-MM-DD string
      const datePart = typeof formData.fechaNacimiento === 'string' && formData.fechaNacimiento.length === 10
        ? formData.fechaNacimiento
        : (formData.fechaNacimiento.split ? formData.fechaNacimiento.split('T')[0] : formData.fechaNacimiento);
      // Use 12:00 UTC to prevent timezone offset moving it to previous day
      dataToSend.fechaNacimiento = new Date(datePart + 'T12:00:00Z').toISOString();
    } else {
      delete dataToSend.fechaNacimiento;
    }

    if (!vecinoData || !vecinoData._id) {
      await addPersona.mutateAsync(dataToSend);
    } else {
      await updatePersonaC.mutateAsync({ ...dataToSend, _id: vecinoData._id });
    }
    onChangeVecino('REFRESH');
    setIsClicked(!isClicked.NuevaPersona);
  }
  
  return (
    <form onSubmit={handleSubmit}>
      <div className="bg-half-transparent w-full fixed nav-item top-0 right-0">
        <div className="overflow-y-scroll float-right h-screen duration-1000 ease-in-out dark:text-gray-200 transition-all dark:bg-[#484B52] bg-gray-100  w-full md:w-2/3 p-8">
          <div className="flex justify-between items-center px-4 py-2 border-b border-gray-200 bg-white rounded-t-md shadow-sm">
            <div className="flex items-center gap-2">
              <div className="w-2.5 h-2.5 rounded-full bg-blue-500 animate-pulse" />
              <p className="text-gray-800 font-semibold text-base md:text-lg">
                {!vecinoData ? "Nueva" : "Editar"} Persona
              </p>
            </div>
            <button
              type="button"
              onClick={() => setIsClicked(!isClicked.NuevaPersona)}
              className="text-gray-400 hover:text-red-500 transition-colors duration-150 p-2 rounded-full hover:bg-gray-100"
              aria-label="Cerrar"
            >
              <MdOutlineCancel className="text-xl md:text-2xl" />
            </button>
          </div>
          <div className="mt-5 space-y-4">
            <div className="md:col-span-2 bg-white p-6 rounded-lg shadow-lg">
              {/* ...campos del formulario... */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4" >
                <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Rut*</label>
                  <input
                    className={inputClass}
                    type="text"
                    placeholder="Ej: 12.345.678-9"
                    name="rut"
                    value={formData.rut}
                    required
                    onChange={handleChange}
                  />
                </div>
                <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Nombres*</label>
                  <input
                    className={inputClass}
                    type="text"
                    placeholder="Nombres"
                    name="nombres"
                    value={formData.nombres}
                    required
                    onChange={handleChange}
                  />
                </div>
                <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Apellido Paterno</label>
                  <input
                    className={inputClass}
                    type="text"
                    placeholder="Apellido Paterno"
                    name="apellidoPaterno"
                    value={formData.apellidoPaterno}
                    onChange={handleChange}
                  />
                </div>
              </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4" >
            <div className="flex flex-col">
              <label className="text-xs font-semibold mb-1">Apellido Materno</label>
              <input
                className={inputClass}
                type="text"
                placeholder="Apellido Materno"
                name="apellidoMaterno"
                value={formData.apellidoMaterno}
                onChange={handleChange}
              />
            </div>
            <div className="flex flex-col">
              <label className="text-xs font-semibold mb-1">Email</label>
              <input
                className={inputClass}
                type="email"
                placeholder="Email"
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
            </div>
            <div className="flex flex-col">
              <label className="text-xs font-semibold mb-1">Teléfono Móvil</label>
              <input
                className={inputClass}
                type="text"
                placeholder="Teléfono Móvil"
                name="telefonoMovil"
                value={formData.telefonoMovil}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4" >
            <div className="flex flex-col">
              <label className="text-xs font-semibold mb-1">Fecha Nacimiento</label>
              <input
                className={inputClass}
                type="date"
                name="fechaNacimiento"
                value={formData.fechaNacimiento ? formData.fechaNacimiento.split('T')[0] : ''}
                onChange={handleChange}
              />
            </div>
            <div className="flex flex-col">
              <label className="text-xs font-semibold mb-1">País de Nacimiento</label>
              <input
                className={inputClass}
                type="text"
                placeholder="País"
                name="paisNacimiento"
                value={formData.paisNacimiento}
                onChange={handleChange}
              />
            </div>
            <div className="flex flex-col">
              <label className="text-xs font-semibold mb-1">Dirección</label>
              <input
                className={inputClass}
                type="text"
                placeholder="Dirección"
                name="direccion"
                value={formData.direccion}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4" >
            <div className="flex flex-col">
              <label className="text-xs font-semibold mb-1">Ciudad</label>
              <input
                className={inputClass}
                type="text"
                placeholder="Ciudad"
                name="ciudad"
                value={formData.ciudad}
                onChange={handleChange}
              />
            </div>
            <div className="flex flex-col">
              <label className="text-xs font-semibold mb-1">Región</label>
              <input
                className={inputClass}
                type="text"
                placeholder="Región"
                name="region"
                value={formData.region}
                onChange={handleChange}
              />
            </div>
            <div className="flex flex-col">
              <label className="text-xs font-semibold mb-1">Género</label>
              <input
                className={inputClass}
                type="text"
                placeholder="Género"
                name="genero"
                value={formData.genero}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4" >
            <div className="flex flex-col">
              <label className="text-xs font-semibold mb-1">Estado Civil</label>
              <input
                className={inputClass}
                type="text"
                placeholder="Estado Civil"
                name="estadoCivil"
                value={formData.estadoCivil}
                onChange={handleChange}
              />
            </div>
            <div className="flex flex-col">
              <label className="text-xs font-semibold mb-1">Especialidad</label>
              <input
                className={inputClass}
                type="text"
                placeholder="Especialidad"
                name="especialidad"
                value={formData.especialidad}
                onChange={handleChange}
              />
            </div>
            <div className="flex flex-col">
              <label className="text-xs font-semibold mb-1">Cargo Muestra Interés</label>
              <input
                className={inputClass}
                type="text"
                placeholder="Cargo de interés"
                name="cargoMuestraInteres"
                value={formData.cargoMuestraInteres}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="grid grid-cols-1 gap-4 mt-4" >
            <div className="flex flex-col">
              <label className="text-xs font-semibold mb-1">Observaciones</label>
              <textarea className={inputClass} rows="4" name="observaciones" value={formData.observaciones} onChange={handleChange} />
            </div>
          </div>
          <div className="grid grid-cols-1 gap-4 mt-4" >
            <div className="flex flex-col">
              <ButtonSubmit
                color="white"
                bgColor={currentColor}
                text={!vecinoData ? "Crear Nuevo" : "Guardar Cambios"}
                borderRadius="10px"
                onClick={handleSubmit}
                width="full"
              />
            </div>
          </div>
              <FooterPages />
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default NuevaPersona;